import { css } from '@genesislcap/web-core';

export const AppManagementStyles = css`
  :host {
    /* insert css styles here */
  }

  rapid-tabs {
    padding: 10px;
  }

  app-management-bond-data-manager {
    height: 100%;
    width: 380px;
    min-width: 380px;
    max-width: 380px;
  }

  app-management-client-watchlist-manager {
    height: 100%;
    width: 450px;
    min-width: 450px;
    max-width: 450px;
  }

  app-management-watchlist-bonds-manager {
    height: 100%;
    width: 100%;
  }
`;
